import { makeStyles } from '@material-ui/core';

const styles = makeStyles((theme) => ({
  trackTitleSearchBox: {
    width: '100%',
    padding: theme.spacing(0),
    position: 'relative',
    justifyContent: 'space-between',
  },
  exactMatchBox: {
    position: 'absolute',
    top: 0,
    right: 0,
    display: 'flex',
    padding: '2px 6px',
    height: 18,
    alignItems: 'center',
    '& .MuiFormControlLabel-label': {
      fontSize: 12,
    },
  },
}));

export default styles;
